const UploadSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M3 9.11765V10.0588C3 10.3084 3.10536 10.5478 3.29289 10.7243C3.48043 10.9008 3.73478 11 4 11H10C10.2652 11 10.5196 10.9008 10.7071 10.7243C10.8946 10.5478 11 10.3084 11 10.0588V9.11765M4.5 6.29412L7 8.64706M7 8.64706L9.5 6.29412M7 8.64706V3"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UploadSvg;
